import { Icon } from '@udemy/icons';
import React from 'react';
import { ToggleInput } from '../toggle-input/toggle-input.react-component';
const CheckboxState = {
  CHECKED: true,
  UNCHECKED: false,
  INDETERMINATE: 'indeterminate'
};

/**
 * The Checkbox component.
 *
 * @privateRemarks
 * Renders a "fakeInput" (TickIcon or CollapseMinus) as a visual representation
 * of the checkbox state.
 *
 * The real mechanism for the checkbox is an internal {@link ToggleInput} component.
 */
export const Checkbox = Object.assign( /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    size = 'small',
    checked,
    ...props
  } = _ref;
  const iconSizeMap = {
    small: 'xsmall',
    large: 'small'
  };
  let fakeInput = /*#__PURE__*/React.createElement(Icon, {
    glyph: "tick",
    className: "ud-fake-toggle-input ud-fake-toggle-checkbox",
    color: "inherit",
    size: iconSizeMap[size],
    label: false
  });

  if (checked === 'indeterminate') {
    fakeInput = /*#__PURE__*/React.createElement(Icon, {
      glyph: "collapse-minus",
      className: "ud-fake-toggle-input ud-fake-toggle-indeterminate-checkbox",
      color: "inherit",
      size: iconSizeMap[size],
      label: false
    });
    checked = false;
  }

  return /*#__PURE__*/React.createElement(ToggleInput, Object.assign({}, props, {
    checked: checked,
    size: size,
    fakeInput: fakeInput,
    inputType: "checkbox",
    ref: ref
  }));
}), {
  STATE: CheckboxState,
  displayName: 'Checkbox'
});
//# sourceMappingURL=checkbox.react-component.js.map